import React from 'react';
import styled from 'styled-components';

const ContentWrapper = styled.div``;

const RecommendedList = () => (
  <ContentWrapper>Recommended List!</ContentWrapper>
);

export default RecommendedList;
